import React from "react";
import { Button, Tooltip } from "antd";
import Icons from "components/icons";
import { DrawerStandart, Localize, localizeByKeyStatic } from "components/service";
import CommunicationConst from "../communication-const";
import CommunicationForms from "../forms";
import { getCommunicationOpenActionLabelKey } from "../helpers/communication-open-action-helper";
import type {
  TCommunicationAuditEntry,
  TCommunicationReferenceOption,
  TCommunicationTask,
  TCommunicationVisibleTab,
} from "../helpers/communication-types-helper";

interface ICommunicationActionFieldProps {
  task: TCommunicationTask;
  canEditRaw: boolean;
  canApprove: boolean;
  currentVisibleTab: TCommunicationVisibleTab;
  equipmentOptions: TCommunicationReferenceOption[];
  flooringOptions: TCommunicationReferenceOption[];
  organizerOptions: TCommunicationReferenceOption[];
  exhibitionOptions: TCommunicationReferenceOption[];
  auditEntry?: TCommunicationAuditEntry;
  onSave: (taskId: string, values: any) => void;
  onApprove: (taskId: string, values: any) => void;
}

const CommunicationActionField: React.FC<ICommunicationActionFieldProps> = ({
  task,
  canEditRaw,
  canApprove,
  currentVisibleTab,
  equipmentOptions,
  flooringOptions,
  organizerOptions,
  exhibitionOptions,
  auditEntry,
  onSave,
  onApprove,
}) => {
  const actionTooltip = localizeByKeyStatic(
    getCommunicationOpenActionLabelKey(task, currentVisibleTab)
  );
  const buttonLabel =
    currentVisibleTab === "audit"
      ? localizeByKeyStatic("COMMUNICATION.Button_View")
      : localizeByKeyStatic("COMMUNICATION.Button_Open");

  return (
    <DrawerStandart
      width={980}
      extraClass="model-form communication-drawer"
      modalButton={
        <Tooltip title={actionTooltip}>
          <Button
            className="communication-action-button"
            icon={currentVisibleTab === "audit" ? <Icons.Information /> : <Icons.Edit />}
          >
            <span className="ellipsis">{buttonLabel}</span>
          </Button>
        </Tooltip>
      }
    >
      <strong className="modal-title">
        <span className="text">
          <Localize>
            {currentVisibleTab === "audit"
              ? "COMMUNICATION.Title_AuditEntry"
              : "COMMUNICATION.Title_EmailChange"}
          </Localize>
        </span>
      </strong>

      <CommunicationForms.Task
        task={task}
        canEditRaw={canEditRaw}
        canApprove={canApprove}
        isAuditView={currentVisibleTab === "audit" || task.status === CommunicationConst.statuses.APPROVED}
        equipmentOptions={equipmentOptions}
        flooringOptions={flooringOptions}
        organizerOptions={organizerOptions}
        exhibitionOptions={exhibitionOptions}
        auditEntry={auditEntry}
        onSave={onSave}
        onApprove={onApprove}
      />
    </DrawerStandart>
  );
};

export default CommunicationActionField;
